import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableCell, TableRow } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card, CardContent } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png";
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent';
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player';
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling'
import Skeleton from '@material-ui/lab/Skeleton';
import DifficultySlider, { marks as difficultyMarks } from "./feedbackSliderDifficulty";
import { feedbackMessages } from "./feedbackSliderDifficulty";
import PainSlider from "./feedbackSliderPain";
import Popover from "@material-ui/core/Popover";
import { withStyles } from "@material-ui/core/styles";
import FlagExerciseForReview from "./flagExercise";
import TextField from '@material-ui/core/TextField';
import SessionSummary from './SessionSummary.js';

//import FeedbackComp from './feedback';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  card: {
    background: 'linear-gradient(90deg, #dce4eb, #cfd1d7ff)',
    borderRadius: 16,
    boxShadow: "0 8px 20px rgba(2,26,50,0.12), 0 2px 6px rgba(2,26,50,0.08)",
    padding: 24,
    [theme.breakpoints.down('lg')]: {
      padding: 20,
    },
    [theme.breakpoints.down('md')]: {
      padding: 16,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 12,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 8,
    },
  },
  paper: {
    borderRadius: 16,
    padding: 8,
    background: "linear-gradient(220deg, rgba(185, 204, 231, 0.55), #6a8caf)",
    width: "100%",
    maxWidth: 1000,
  minHeight: 300,
    boxSizing: "border-box",
    [theme.breakpoints.down('lg')]: {
      maxWidth: 900,
  minHeight: 250,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 850,
  minHeight: 180,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
  minHeight: 100,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 400,
  minHeight: 60,
    },
  },
  feedbackText: {
    marginBottom: 0,
    textAlign: "center",
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.85rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
    maxWidth: 700,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  feedbackSubText: {
    marginBottom: "3%",
    textAlign: "center",
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
  orangeInput: {
    fontSize: 18,
    backgroundColor: '#F0F8FF',
    borderRadius: 4,
    '&.MuiOutlinedInput-root': {
      backgroundColor: '#F0F8FF',
      borderRadius: 4,
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#fb741a',
      },
    },
     [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.95rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
  orangeLabel: {
    fontSize: 18,
    '&.Mui-focused': {
      color: '#fb741a',
    },
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.95rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
  },
  mobileCompleteButton: {
    background: '#fb741a',
    color: '#fff',
    fontWeight: 700,
    padding: '3.7px 12px',
    marginRight: 15,
    borderRadius: 14,
    marginBlock: 1,
    boxShadow: "none",
    width: '95%',
    transition: 'background-color 200ms ease, transform 120ms ease',
    '&:hover': {
      background: '#002D55'
    },
    '&:active': {
      background: '#002D55',
      transform: 'translateY(1px)'
    }
  },
  continueButton: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: "15px 10px",
    border: "0.5px solid",
    fontWeight: 700,
    lineHeight: 0.5,
    borderRadius: 18,
    backgroundColor: "#fb741a",
    borderColor: "transparent",
    color: "#FFFFFF",
    '&:hover': {
      background: '#002D55'
    },
    '&:active': {
      background: '#002D55',
      transform: 'translateY(1px)'
    },
    [theme.breakpoints.up('lg')]: {
      padding: "16px 62px",
    },
    [theme.breakpoints.down('md')]: {
      padding: "14px 50px",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "12px 50px",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "10px 50px",
    },
  },
}));

const ContinueButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 'clamp(12px, 1vw, 15px)',
    padding: "15px 10px",
    lineHeight: 0.5,
    backgroundColor: "#002D55",
    borderColor: "#002D55",
    color: "#FFFFFF",
    "&:hover": {
            backgroundColor: '#6a8caf', // light grey that fits the theme
      color: 'orange',
      fontWeight: 'bold',
            borderRadius: 4
          },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

const UploadVideoButton = withStyles({
  root: {
    boxShadow: "none",
    scale: "0.8",
    textTransform: "none",
    fontSize: 'clamp(12px, 1vw, 15px)',
    padding: "10px 10px",
    border: "0.5px solid",
    lineHeight: 0.5,
    backgroundColor: "#1a90ff",
    borderColor: "#1a90ff",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#1a90ff",
      borderColor: "#1a90ff",
      boxShadow: "none"
    },
    //"&:active": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    //  backgroundColor: "#002D55",
    //  borderColor: "#002D55"
    //},
    //"&:focus": {
    //  boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
    //}
  }
})(Button);

const FeedbackCompPopOver = (props) => {
  const className = props.className

  const classes = useStyles();

  const { innerWidth: width, innerHeight: height } = window;

  const [difficulty, setDifficulty] = useState(0)
  const [pain, setPain] = useState(0)
  const [note, setNote] = useState("");
  const [showSessionSummary, setShowSessionSummary] = useState(false);
  // Optional partial-completion capture. The patient's prescribed dose is the
  // default; opening the panel signals they want to record a different value.
  const prescribedSets = props.exercise?.sets ?? null;
  const prescribedReps = props.exercise?.repetitions ?? null;
  const prescribedTime = props.exercise?.time ?? null;
  // Infer dose type the same way the rest of the app does: explicit doseType wins,
  // otherwise a non-zero time means time-based, else repetitions-based.
  const inferredDoseType = (props.exercise?.doseType)
    || ((prescribedTime != null && prescribedTime > 0) ? 'time' : 'repetitions');
  const useTimeDose = inferredDoseType === 'time';
  const [showCompletion, setShowCompletion] = useState(false);
  const [completedSets, setCompletedSets] = useState(prescribedSets ?? "");
  const [completedReps, setCompletedReps] = useState(prescribedReps ?? "");
  const [completedTime, setCompletedTime] = useState(prescribedTime ?? "");

  useEffect(() => {
    if (!props.open || showSessionSummary) {
      return;
    }

    setDifficulty(0);
    setPain(0);
    setNote("");
    setShowCompletion(false);
    setCompletedSets(prescribedSets ?? "");
    setCompletedReps(prescribedReps ?? "");
    setCompletedTime(prescribedTime ?? "");
  }, [
    props.open,
    props.exercise?.identifier,
    prescribedSets,
    prescribedReps,
    prescribedTime,
    showSessionSummary,
  ]);

  const [token, _] = useState(useSelector(state => state.auth.token))
  // console.log("Exercise object:", props.exercise);

  const getDifficultyLabel = (value) => {
    // Find the mark with the matching value
    const mark = difficultyMarks.find(m => m.value === value);
    // Return the label, or a fallback
    return mark ? mark.label : "Good.";
  };

  const difficultyLabel = difficultyMarks.find(mark => mark.value === difficulty)?.label;
  const difficultyMessage = feedbackMessages[difficulty];
  const getPainMessage = (painValue) => {
  if (painValue === 0) {
      return "no pain or discomfort reported";
    } else if (painValue < 30) {
      return "low degree of pain reported";
    } else if (painValue >= 30 && painValue <= 50) {
      return "moderate amount of pain reported";
    } else if (painValue >= 51 && painValue <= 65) {
      return "moderately high pain reported";
    } else if (painValue > 62 && painValue <= 75) {
      return "high degree of pain reported. We will provide another exercise that is usually less painful";
    } else if (painValue > 75) {
      return "very high degree of pain reported. We will provide another exercise that is usually less painful";
    };
    return "";
  };
  
  // Exercise feedback POST
  const submitExerciseFeedback = async () => {
    const toIntOrNull = (v) => {
      if (v === "" || v === null || v === undefined) return null;
      const n = parseInt(v, 10);
      return Number.isNaN(n) ? null : n;
    };
    const d = {
      diagnosis: props.diagnosis.identifier,
      exercise: props.exercise.identifier,
      difficulty: getDifficultyLabel(difficulty),
      pain,
      note,
      // include optional scoping fields when available
      ...(props.sessionId ? { session_id: props.sessionId } : {}),
      ...(props.treatmentId ? { treatment_id: props.treatmentId } : {})
    };
    // Only attach completion fields when the patient actually opened the panel
    // — backend defaults each missing value to its prescribed counterpart.
    if (showCompletion) {
      const cs = toIntOrNull(completedSets);
      const cr = toIntOrNull(completedReps);
      const ct = toIntOrNull(completedTime);
      if (cs !== null) d.completed_sets = cs;
      // Only attach the dose-type-relevant completion field, so reps aren't
      // recorded for a time-based exercise (and vice versa).
      if (!useTimeDose && cr !== null) d.completed_repetitions = cr;
      if (useTimeDose && ct !== null) d.completed_time = ct;
    }
    const response = await fetch("https://api.virtus-one.com/treatment/feedback/submit", {
      headers: {
        "Authorization": `Token ${token}`,
        "content-type": "application/json"
      },
      method: "POST",
      body: JSON.stringify(d)
    });

    if (response.ok) {
      try { window.dispatchEvent(new CustomEvent('exerciseFeedbackSubmitted')); } catch (e) {}
      // Surface the new feedback row id so the Session Summary can PATCH it later.
      try {
        const body = await response.clone().json();
        if (body && body.feedback_id && typeof props.onFeedbackSubmitted === 'function') {
          props.onFeedbackSubmitted(props.exercise.identifier, body.feedback_id);
        }
      } catch (e) { /* non-JSON response is fine */ }
      if (props.isLastExercise) {
        setShowSessionSummary(true); // Show session summary
      } else {
        props.onFeedbackConfirm();
        props.handleClose();
      }
    } else {
      alert("Exercise feedback error");
    }
  };

// Session feedback POST
  const submitSessionFeedback = async ({ likeStatus, feedback }) => {
    // console.log("Session feedback:", {
    //   sessionId: props.sessionId,
    //   likeStatus,
    //   feedback
    // });
    const payload = {
      session_id: props.sessionId,
      like_status: likeStatus,
      feedback,
      ...(props.treatmentId ? { treatment_id: props.treatmentId } : {})
    };
    const response = await fetch("https://api.virtus-one.com/treatment/session/feedback/", {
      headers: {
        "Authorization": `Token ${token}`,
        "content-type": "application/json"
      },
      method: "POST",
      body: JSON.stringify(payload)
    });
    if (response.ok) {
      try { window.dispatchEvent(new CustomEvent('exerciseFeedbackSubmitted')); } catch (e) {}
      setShowSessionSummary(false);
      if (props.onSessionFeedbackComplete) {
        props.onSessionFeedbackComplete();
      }
      props.onFeedbackConfirm();
      props.handleClose();
    } else {
      const errorText = await response.text();
      alert("Session feedback error: " + errorText);
    }
  };


  return (
    <Popover
      PaperProps={{ style: { borderRadius: 'clamp(16px, 1.2vw, 16px)' } }}
      open={props.open}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: window.innerHeight / 2,
        left: window.innerWidth / 2
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <div style={{ borderRadius: 16, width: "100%", height: '100%', display: "flex", justifyContent: "center", alignItems: "center", background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        <Paper elevation={4} className={classes.paper} style={{ height: '100%', width: '100%', maxWidth: 'clamp(380px, 40vw, 550px)', minHeight: 'clamp(200px, 22vw, 300px)' }}>
          <Card elevation={2} className={classes.card} style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className={classes.root} style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              {!showSessionSummary ? (
                <Grid container direction="column" justifyContent="center" alignItems="center" style={{ width: "100%", padding: 4 }}>
                  <Grid item xs={12} style={{ width: "100%", marginBottom: 0 }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%", marginBottom: 0 }}>
                      <div style={{ width: '100%' }}>
                        <DifficultySlider
                          setValue={setDifficulty}
                          value={difficulty}
                        />
                      </div>
                      <div style={{ width: '100%', marginTop: 'clamp(12px, 1.5vw, 20px)' }}>
                        <PainSlider
                          setValue={setPain}
                          value={pain}
                        />
                      </div>
                      {/* Optional partial-completion capture. Only render the inputs that
                          correspond to a non-null prescribed value, so the patient is never
                          asked about (e.g.) reps for a time-based exercise. */}
                      {(prescribedSets != null || prescribedReps != null || prescribedTime != null) && (
                        <div style={{ width: '100%', marginTop: 'clamp(8px, 1vw, 14px)' }}>
                          <Link
                            component="button"
                            type="button"
                            onClick={() => setShowCompletion(s => !s)}
                            style={{ color: '#fb741a', fontWeight: 600, fontSize: 'clamp(0.78rem, 0.9vw, 0.95rem)' }}
                          >
                            {(() => {
                              const doseWord = useTimeDose ? 'duration' : 'repetitions';
                              return showCompletion
                                ? `How many sets and ${doseWord} did you complete?`
                                : `Click if you didn't complete all sets and ${doseWord}.`;
                            })()}
                          </Link>
                          {showCompletion && (
                            <div style={{ display: 'flex', gap: 'clamp(6px, 0.8vw, 12px)', marginTop: 'clamp(6px, 0.8vw, 10px)', flexWrap: 'wrap' }}>
                              {prescribedSets != null && (
                                <TextField
                                  label={`Sets (of ${prescribedSets})`}
                                  type="number"
                                  size="small"
                                  variant="outlined"
                                  value={completedSets}
                                  onChange={e => setCompletedSets(e.target.value)}
                                  InputProps={{ inputProps: { min: 0, max: prescribedSets } }}
                                  style={{ width: 'clamp(110px, 12vw, 150px)' }}
                                />
                              )}
                              {!useTimeDose && prescribedReps != null && prescribedReps > 0 && (
                                <TextField
                                  label={`Reps (of ${prescribedReps})`}
                                  type="number"
                                  size="small"
                                  variant="outlined"
                                  value={completedReps}
                                  onChange={e => setCompletedReps(e.target.value)}
                                  InputProps={{ inputProps: { min: 0, max: prescribedReps } }}
                                  style={{ width: 'clamp(110px, 12vw, 150px)' }}
                                />
                              )}
                              {useTimeDose && prescribedTime != null && prescribedTime > 0 && (
                                <TextField
                                  label={`Seconds (of ${prescribedTime})`}
                                  type="number"
                                  size="small"
                                  variant="outlined"
                                  value={completedTime}
                                  onChange={e => setCompletedTime(e.target.value)}
                                  InputProps={{ inputProps: { min: 0, max: prescribedTime } }}
                                  style={{ width: 'clamp(110px, 12vw, 160px)' }}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      <TextField
                        label="Notes (optional)"
                        multiline
                        rows={2}
                        variant="outlined"
                        value={note}
                        onChange={e => setNote(e.target.value)}
                        style={{ width: "100%", marginTop: 'clamp(6px, 1vw, 14px)' }}
                        InputProps={{ classes: { input: classes.orangeInput, root: classes.orangeInput }, style: { color: '#002D55' } }}
                        InputLabelProps={{ classes: { root: classes.orangeLabel }, style: { color: '#002D55' } }}
                      />
                    </div>
                  </Grid>
                  <Grid container direction="row" justifyContent="center" alignItems="center" style={{ marginRight: 0, marginTop: "1.5%", marginBottom: "1%" }}>
                    <Grid item xs={12} style={{ padding: 0, marginLeft: "0%", marginRight: 0, display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography
                        variant="body1"
                        className={classes.feedbackText}
                      >
                        <span style={{ display: 'inline-block', width: '100%', maxWidth: 'clamp(420px, 42vw, 600px)', marginLeft: 'auto', marginRight: 'auto', color: '#002D55' }}>
                          We noted a {getPainMessage(pain)}. <br /> {`${difficultyMessage}`} <br />
                        </span>
                      </Typography>
                      <Button onClick={submitExerciseFeedback} className={classes.continueButton} style={{ marginTop: "3.6%" }}>
                        SEND FEEDBACK
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <SessionSummary
                  open={true}
                  anchor={props.anchor}
                  container={props.container}
                  exercises={props.allExercises}
                  expectedExerciseLength={props.expectedExerciseLength}
                  feedbackIds={props.feedbackIds}
                  token={token}
                  onContinue={submitSessionFeedback}
                  onSkip={() =>
                    submitSessionFeedback({
                      likeStatus: "skipped",
                      feedback: "User skipped session feedback."
                    })
                  }
                />
              )}
            </div>
          </Card>
        </Paper>
      </div>
    </Popover>

  );
};


export default FeedbackCompPopOver;
